import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge";

/**
 * Presents a daisyUI dropdown as the shell's own menu. The shell replies with the chosen index
 * and the matching web item is clicked, so the link keeps its Turbo method and confirm. The web
 * dropdown stays hidden while the bridge is connected (overrides.css); until then, and in a
 * shell without this component, it opens as usual.
 *
 *   <div class="dropdown" data-controller="bridge--menu" data-bridge-title="Jane Doe">
 *     <div role="button" data-action="click->bridge--menu#show">…</div>
 *     <ul class="dropdown-content">
 *       <li><a data-bridge--menu-target="item" data-bridge-destructive="true">Delete</a></li>
 *     </ul>
 *   </div>
 */
export default class extends BridgeComponent {
  static component = "menu";
  static targets = ["item"];

  declare readonly itemTargets: HTMLElement[];

  show() {
    if (!this.enabled) return;

    const items = this.itemTargets.map((element, index) => {
      const item = new BridgeElement(element);
      return { index, title: item.title, destructive: item.bridgeAttribute("destructive") === "true" };
    });

    this.send("display", { title: this.bridgeElement.bridgeAttribute("title"), items }, (message: any) => {
      new BridgeElement(this.itemTargets[message.data.selectedIndex]).click();
    });
  }
}
